import { render } from "./EmptyEditor.vue?vue&type=template&id=ba40494a&ts=true"
import script from "./EmptyEditor.vue?vue&type=script&lang=ts"
export * from "./EmptyEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__